import '../../css/misc/contactform.css';
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { setContactProcessed, closeConversationByAgent } from '../../redux/interactionsSlice';
import ChatsService from '../../controllers/ChatController';

class MailContact extends Component {

    constructor(props) {
        super(props);
        this.handleMessage = this.handleMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    

    handleMessage(event) {
        console.log("MailContact handleMessage: ", event.data);

        if (event.data.Method === "SetFormChange" && event.data.Status === "MAILCLOSE") {
            ChatsService.setContactProcessed(this.props.interaction.id, false, e => {
                this.props.setContactProcessed(this.props.interaction.id);
            });

            setTimeout(() => {
                this.props.closeConversationByAgent(this.props.interaction.id);
                ChatsService.closeConversation(this.props.interaction.id);
            }, 5000);
        }
    }

    render() {
        let url = this.props.searchForms.toLowerCase().split("search")[0];

        if (this.props.interaction.closed) {
            var emailMessageNumber = this.props.interaction.messages[0].messageId;
            var inbox = this.props.interaction.messages[0].inbox;
            var data = JSON.parse(localStorage.getItem("fc-logged"));
            var rcu = localStorage.getItem("faRCUser");
            var rcp = localStorage.getItem("faRCPwd");
            var roundcubeUrl = localStorage.getItem("faRC");
            url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_fainbox=1`
        }

        return (
            <Row>
                <Col style={{ height: "70vh" }}>

                    {
                        !this.props.interaction.closed &&
                        <iframe title="mailForm" src={`${url}?state=incoming&campaignId=${this.props.interaction.campaignId}&mailId=${this.props.interaction.id}&pin=${this.props.userId}&groupId=${this.props.interaction.groupId}`} width={"100%"} height={"100%"}></iframe>
                    }

                    {
                        this.props.interaction.closed &&
                        <iframe title="Mail" src={url} width={"100%"} height={"720px"}></iframe>
                    }
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {

    return {
        interaction: state.interaction.current,
        searchForms: state.parameters.searchForms,
        userId: state.agent.userId
    };

};

export default compose(connect(mapStateToProps, { setContactProcessed, closeConversationByAgent }), withTranslation())(MailContact);
